export enum SearchFieldKey {
  AnyField = "AnyField",
  Title = "Title",
  Author = "Author",
  Series = "Series",
  Subject = "Subject",
  Note = "Note",
  Tag = "Tag",
  ISBN = "ISBN",
  ISSN = "ISSN",
  UPC = "UPC",
  CallNumber = "CallNumber",
}

export enum SearchFieldTranslateKey {
  AnyField = "advancedSearch_anyField",
  Author = "advancedSearch_author",
  CallNumber = "CallNumber",
  ISBN = "advancedSearch_isbn",
  ISSN = "advancedSearch_issn",
  Note = "advancedSearch_note",
  Series = "advancedSearch_series",
  Subject = "advancedSearch_subject",
  Tag = "advancedSearch_tag",
  Title = "advancedSearch_title",
  UPC = "advancedSearch_upc",
}
